import { render, staticRenderFns } from "./SendConsultationFeeInvoiceModal.vue?vue&type=template&id=3344151a&scoped=true"
import script from "./SendConsultationFeeInvoiceModal.vue?vue&type=script&lang=js"
export * from "./SendConsultationFeeInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./SendConsultationFeeInvoiceModal.vue?vue&type=style&index=0&id=3344151a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3344151a",
  null
  
)

export default component.exports